export const EXTOLE_ELEMENT_ID = 'extole_zone_web_cta'
export const EXTOLE_ZONE_NAME = 'web_cta'
export const EXTOLE_CONTENT_ZONE_NAME = 'web_content'

export const EXTOLE_CONTAINER = {
  PROD: 'prod',
  STAGING: 'staging',
} as const
